// GAVION booking: demo booking link and reminders (English twin of booking.fr.ts).
export const bookingEn = {
  settings: {
    title: "My demo calendar",
    loading: "Loading your demo calendar…",
    load_error: "Settings are unavailable right now.",
    retry: "Try again",
    rep: "Representative",
    me: "Me",
    link_title: "Booking link",
    enabled: "Link active",
    connect_first: "Connect Microsoft 365 first",
    connect_link: "Open integrations",
    slug: "Link address",
    copy: "Copy the link",
    copied: "Link copied",
    copy_hint: "Save and turn the link on to copy it.",
    copy_failed: "Could not copy: select the link and copy it by hand.",
    rep_connect_first: "This representative must connect Microsoft 365",
    hours_title: "Availability",
    tz: "Time zone",
    days: { "1": "Monday", "2": "Tuesday", "3": "Wednesday", "4": "Thursday", "5": "Friday", "6": "Saturday", "7": "Sunday" },
    closed: "Closed",
    from: "Start",
    to: "End",
    add_short: "Add a range",
    remove_short: "Remove",
    add_range: "Add a range on %{day}",
    remove_range: "Remove the %{day} range",
    limits_title: "Notice and horizon",
    notice: "Minimum notice (hours)",
    horizon: "Bookable up to (days)",
    reminders_title: "Reminders to the prospect",
    r24h: "24 h before",
    rmorning: "The same morning at 8 a.m.",
    r1h: "1 h before",
    custom_minutes: "Custom reminder (minutes before, optional)",
    custom_preview: "Sent %{when} the demo",
    custom_line: "Line added to the reminder (optional, 300 characters)",
    custom_counter: "%{count} / 300",
    save: "Save",
    saved: "Demo calendar saved",
    errors: {
      slug_taken: "This address is already taken.",
      slug_reserved: "This link is reserved, please choose another.",
      invalid_slug: "Invalid address: lower-case letters, digits and dashes.",
      invalid_hours: "Invalid ranges: the start must come before the end, on quarter hours, without overlap (at most 4 ranges a day).",
      invalid_notice: "The notice must be between 0 and 72 hours.",
      invalid_horizon: "The horizon must be between 1 and 60 days.",
      invalid_reminders: "Custom reminder: between 15 and 10,080 minutes; a line of at most 300 characters.",
      invalid_tz: "Invalid time zone.",
      microsoft_not_connected: "Connect Microsoft 365 first",
      forbidden: "Access denied.",
      not_found: "Representative not found.",
      unavailable: "Cannot save right now.",
    },
  },
  deal: {
    reminders_on: "Automatic reminders to the prospect",
    heading: "Planned reminders",
    none: "No reminder planned.",
    no_invitee: "No reminder: the meeting has no invitee",
    demo_note: "Reminder list available in production",
    recipient: "Recipient: %{email}",
    sent_to: "to %{email}",
    kinds: { "24h": "24 h before", morning: "The same morning (8 a.m.)", "1h": "1 h before", custom: "Custom reminder" },
    status: { pending: "Planned", sent: "Sent", skipped: "Not sent", cancelled: "Cancelled", failed: "Failed to send" },
    reasons: {
      meeting_started: "meeting already started",
      suppressed: "address unsubscribed",
      rep_disabled: "reminders turned off for this representative",
      retry: "will try again",
      graph_bad_request: "Microsoft 365 refused the message",
      microsoft_not_connected: "Microsoft 365 is not connected",
      microsoft_needs_reauth: "Microsoft 365 needs a reconnection",
      m365_not_configured: "Microsoft 365 is not configured",
      graph_unavailable: "Microsoft 365 is unavailable",
      needs_review: "send to check in Outlook",
      skipped_other: "not sent",
      failed_other: "technical error, try again later",
    },
    saved_on: "Reminders on for this demo",
    saved_off: "Reminders off for this demo",
    errors: {
      forbidden: "Only the demo's representative or an admin can change this.",
      no_active_demo: "This demo no longer has an Outlook event.",
      unavailable: "Cannot change it right now.",
    },
  },
};
